<template>
    <div>
        <van-nav-bar
            title="我的优惠券"
            left-text="返回"
            left-arrow
            @click-left="clickback"
            />
        <van-tabs v-model="activate" type="card" color="#488aff" style="width:100%;">
            <van-tab title="未使用" name="use">
                <coupon :params="{'status__in': '0'}"></coupon>
            </van-tab>
            <van-tab title="已使用" name="unuse">
                <coupon :params="{'status__in': '1,3'}"></coupon>
            </van-tab>
            <van-tab title="已过期" name="expired">
                <coupon :params="{'status__in': '2,4'}"></coupon>
            </van-tab>
        </van-tabs>

    </div>
</template>

<script>
import { NavBar, Button,  List,  Tab, Tabs } from 'vant'
import coupon from '@/view/user/components/coupon'

export default {
    components: {
        [NavBar.name]: NavBar,
        [Button.name]: Button,
        [Tab.name]: Tab,
        [Tabs.name]: Tabs,
        [List.name]: List,
        coupon
    },
    data() {
        return {
            activate: 'use'
        }
    },
    mounted() {
    },
    methods: {
        clickback() {
            try {
                this.$router.go(-1)
            } catch {
                this.$router.push(`/user`)
            }
        }
    }
}
</script>

<style lang="less" scoped>
</style>